import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { Popup } from '@atlaskit/popup';
import { Box } from '@atlaskit/primitives/compiled';
import { useProductDependencies } from '@atlassian/company-hub-common';
import { KeyboardHighlightProvider } from '@atlassian/search-dialog';
import { SearchDropdown } from './search-dropdown';
import { SearchTextField } from './search-textfield';
export var ArticleSearchComponent = function ArticleSearchComponent(_ref) {
  var _inputBoxRef$current;
  var isEditor = _ref.isEditor,
    placeholderText = _ref.placeholderText;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    queryWord = _useState2[0],
    setQueryWord = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showDropdown = _useState4[0],
    setShowDropdown = _useState4[1];
  var inputBoxRef = useRef(null);
  var inputRef = useRef(null);
  var _useState5 = useState((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth),
    _useState6 = _slicedToArray(_useState5, 2),
    _ = _useState6[0],
    setInputWidth = _useState6[1];
  var _useProductDependenci = useProductDependencies(),
    cloudId = _useProductDependenci.cloudId,
    helpCenterAri = _useProductDependenci.helpCenterAri;
  useEffect(function () {
    var listener = function listener() {
      var _inputBoxRef$current2;
      return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
    };
    var unbind = bind(window, {
      type: 'resize',
      listener: listener
    });
    return unbind;
  }, []);
  var closeDropdown = function closeDropdown() {
    if (showDropdown) {
      setShowDropdown(false);
    }
  };
  var trigger = useCallback(function (triggerProps) {
    var handleInput = function handleInput(searchInput) {
      setQueryWord(searchInput);
      setShowDropdown(searchInput.trim().length > 0);
    };
    return /*#__PURE__*/React.createElement(Box, {
      ref: inputBoxRef
    }, /*#__PURE__*/React.createElement(SearchTextField, _extends({
      keyboardRef: inputRef
    }, triggerProps, {
      ref: triggerProps.ref,
      onInput: handleInput,
      isReadOnly: isEditor,
      placeholderText: placeholderText,
      showDropdown: showDropdown,
      queryWord: queryWord
    })));
  }, [isEditor, placeholderText, showDropdown, queryWord]);
  return /*#__PURE__*/React.createElement(Popup, {
    shouldReturnFocus: false,
    content: function content(contentProps) {
      var _inputBoxRef$current3;
      return /*#__PURE__*/React.createElement(KeyboardHighlightProvider, {
        listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
      }, /*#__PURE__*/React.createElement(SearchDropdown, _extends({}, contentProps, {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri || '',
        inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
        queryWord: queryWord
      })));
    },
    isOpen: showDropdown,
    autoFocus: false,
    placement: "bottom-start",
    trigger: trigger,
    onClose: closeDropdown
  });
};